import { css } from '@emotion/react'
import type { HTMLAttributes, ReactNode } from 'react'

export interface PostHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
	title?: ReactNode
	desc?: ReactNode
	right?: ReactNode
}

export default function PostHeader({ title, desc, right, children, ...props }: PostHeaderProps) {
	return (
		<header
			css={css`
				display: flex;
				justify-content: space-between;
				align-items: center;
			`}
			{...props}
		>
			<div
				css={css`
					display: grid;
					grid-template-rows: auto auto;
				`}
			>
				<div
					css={css`
						font-size: 16px;
						font-weight: 500;
						line-height: 24px;
					`}
				>
					{title}
				</div>
				<div
					css={css`
						color: var(--tint-tertiary);
						font-size: 12px;
						line-height: 18px; /* 150% */
						overflow: hidden;
					`}
				>
					{desc}
				</div>
			</div>

			<div
				css={css`
					display: flex;
					align-items: center;
					gap: 8px;
				`}
			>
				{right}
			</div>
		</header>
	)
}
